const enum FilterTypes {
    STRING = 'string',
    NUMBER = 'number'
}

export default FilterTypes;